<div class="center">
  <form [formGroup]="postpaidFormGroup" class="flex-col width-800">
    <h2 class="center margin-y-10">
      Create Postpaid Subscription
    </h2>

    <div class="flex-row margin-y-10" *ngIf="context">
      <label class="width-50 font-20 bold">Category services:</label>
      <div class="flex-grow font-20 margin-l-10">
        Applicable for all services in this category
        <div>{{ includedCategoryServicesText }}</div>
      </div>
    </div>
    <div class="flex-row margin-y-10" *ngIf="context && context.excludableServices && context.excludableServices.length">
      <label class="width-50 font-20 bold">Exclude Services:</label>
      <ng-select formControlName="excludedServices" name="excludedServices" placeholder="Select services to exclude"
        class="flex-grow font-20 margin-l-10" [multiple]="true">
        <ng-option *ngFor="let item of context.excludableServices" [value]="item">{{item.name}}{{item.active ? '' : ' (inactive)'}}</ng-option>
      </ng-select>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Target Segment:</label>
      <div class="flex-grow font-20 margin-l-10 target-segment">
        <label class="font-20">
          <input type="radio" name="targetSegment" [value]="'entireCity'" formControlName="targetSegment">
          <span>Entire City</span>
        </label>
        <label class="font-20">
          <input type="radio" name="targetSegment" [value]="'femaleGender'" formControlName="targetSegment">
          <span>Female gender base</span>
        </label>
        <label class="font-20">
          <input type="radio" name="targetSegment" [value]="'userSelectors'" formControlName="targetSegment">
          <span>User Selector</span>
        </label>
        <label class="font-20">
          <input type="radio" name="targetSegment" [value]="'autoAssign'" formControlName="targetSegment">
          <span>Auto Assign</span>
        </label>
      </div>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Subscription Priority:</label>
      <input formControlName="priority" class="flex-grow font-20 margin-l-10 no-spinner" name="priority" type="number"
        min="1"
        (keydown)="blockInvalidNumberKeys($event)" (wheel)="$event.preventDefault()" />
    </div>

    <div class="flex-row margin-y-10" *ngIf="showUserSelector">
      <label class="width-50 font-20 bold">User Selector:</label>
      <ng-select formControlName="userSelector" name="userSelector" placeholder="Select User Selector"
        class="flex-grow font-20 margin-l-10">
        <ng-option *ngFor="let item of userSelectors" [value]="item">{{item.name}}</ng-option>
      </ng-select>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Rule Name:</label>
      <input formControlName="ruleName" name="ruleName" placeholder="Rule Name" class="flex-grow font-20 margin-l-10" />
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Display Name (Optional):</label>
      <ng-select formControlName="ruleTitle" name="ruleTitle" placeholder="Select display name"
        class="flex-grow font-20 margin-l-10">
        <ng-option *ngFor="let title of subscriptionTitles" [value]="title">{{title}}</ng-option>
      </ng-select>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Start Time:</label>
      <p-calendar formControlName="startDate" icon="pi pi-calendar" class="font-20 margin-l-10" name="startDate"
        [showIcon]=true dateFormat="d/m/yy" [minDate]="today" [defaultDate]="today"
        [selectOtherMonths]="true" showTime="true" hourFormat="24" [showButtonBar]="true"
        [stepMinute]="30">
      </p-calendar>
    </div>

    <div class="flex-row margin-y-10" *ngIf="showUserSelector">
      <label class="width-50 font-20 bold">End Time:</label>
      <p-calendar formControlName="endDate" icon="pi pi-calendar" class="font-20 margin-l-10" name="endDate"
        [showIcon]=true dateFormat="d/m/yy" [minDate]="formValue('startDate') || today"
        [selectOtherMonths]="true" showTime="true" hourFormat="24" [showButtonBar]="true"
        [stepMinute]="30">
      </p-calendar>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Rule Type</label>
      <ng-select formControlName="ruleType" name="ruleType" placeholder="Select Rule Type" [multiple]=false
        class="flex-grow font-20 margin-l-10" [disabled]="isRuleTypeLocked">
        <ng-option *ngFor="let type of eligibleRuleTypes" [value]="type">{{ruleTypeLabel(type)}}</ng-option>
      </ng-select>
    </div>

    <div formArrayName="rules">
      <div *ngFor="let rule of rules.controls; let i = index" [formGroupName]="i">

        <label class="width-50 font-20 bold">Rule {{i+1}}:</label>
        <button mat-stroked-button type="button" (click)="deleteRule(i)" [disabled]="rules.length === 1" color="warn"
          class="right-align">
          <mat-icon>delete</mat-icon>
        </button>

        <div class="margin-l-50">
          <div class="flex-row margin-y-10">
            <label class="width-50 font-20 bold">Validity Type:</label>
            <ng-select formControlName="validityType" name="validityType" placeholder="Select validity type"
              class="flex-grow font-20 margin-l-10">
              <ng-option *ngFor="let validityType of validityTypes" [value]="validityType">{{validityType}}</ng-option>
            </ng-select>
          </div>

          <div class="flex-row margin-y-10" *ngIf="!isPaidUnlimited(rule)">
            <label class="width-50 font-20 bold">{{ maxValueLabel(rule) }}:</label>
            <input formControlName="maxValue" class="flex-grow font-20 margin-l-10 no-spinner" name="maxValue" type="number"
              min="1" (keydown)="blockInvalidNumberKeys($event)" (input)="rejectNonPositiveAmount($event, rule.get('maxValue'))"
              (wheel)="$event.preventDefault()" />
          </div>

          <div class="flex-row margin-y-10">
            <label class="width-50 font-20 bold">Amount to be deducted:</label>
            <input formControlName="amount" class="flex-grow font-20 margin-l-10 no-spinner" name="amount" type="number"
              min="0" (keydown)="blockInvalidNumberKeys($event)" (wheel)="$event.preventDefault()" />
          </div>
          <div class="flex-row">
            <label class="width-50"></label>
            <span class="field-info margin-l-10">{{ taxInfoText }}</span>
          </div>

          <div class="flex-row margin-y-10" *ngIf="isPaidUnlimited(rule)">
            <label class="width-50 font-20 bold">Period In Days:</label>
            <input formControlName="periodInDays" class="flex-grow font-20 margin-l-10 no-spinner" name="periodInDays"
              type="number" min="1" step="1" (keydown)="blockInvalidNumberKeys($event)"
              (input)="rejectNonPositiveAmount($event, rule.get('periodInDays'))" (wheel)="$event.preventDefault()" />
          </div>

          <div class="flex-row margin-y-10" *ngIf="rule.get('validityType').value === 'earnings'">
            <label class="width-50 font-20 bold">Cashback Type:</label>
            <ng-select formControlName="cashbackType" name="cashbackType" placeholder="Select cashback type"
              class="flex-grow font-20 margin-l-10" (change)="onCashbackTypeChange(rule)">
              <ng-option *ngFor="let cashbackType of cashbackTypes" [value]="cashbackType">{{cashbackType}}</ng-option>
            </ng-select>
          </div>

          <div class="flex-row margin-y-10" *ngIf="rule.get('validityType').value === 'earnings' && rule.get('cashbackType').value === 'rides'">
            <label class="width-50 font-20 bold">Minimum Rides for Cashback:</label>
            <input formControlName="cashbackMinValue" class="flex-grow font-20 margin-l-10 no-spinner" name="cashbackMinValue"
              type="number" min="1" (keydown)="blockInvalidNumberKeys($event)" (wheel)="$event.preventDefault()" />
          </div>
        </div>

      </div>
    </div>

    <div class="margin-y-10 flex-row pull-right">
      <button mat-stroked-button type="button" (click)="addRule()" [disabled]="!canAddRule">
        <mat-icon>add</mat-icon>
        Add Rule
      </button>
    </div>

    <div class="margin-y-10 flex-row pull-right">
      <button mat-raised-button class="btn-primary" (click)="createPostpaidRule()"> Create Postpaid Rule </button>
    </div>
  </form>
</div>
<app-toaster [config]="toasterService.toaster"></app-toaster>
